export enum InfoBannerType {
    INFO,
    DANGER,
    SUCCESS
}
